import React from 'react'
import tw from 'twin.macro'
import Image from 'src/assets/images/mc-onboarding-welcome.svg'
import { Typography } from '@mui/material'
import { colors } from 'src/theme'
import { Button } from 'src/components/shared/Button'
import { CircleRightMajor } from '@shopify/polaris-icons'

interface Props {
  onNext: () => void
}

export const CustomerOnboardingWelcome = ({ onNext }: Props) => {
  return (
    <div
      css={tw`border border-solid border-[#EDEDED] rounded-2xl p-4 pt-6 w-[426px] bg-white flex flex-col items-center`}
    >
      <img src={Image} />
      <Typography css={tw`my-2 text-center`} variant="h4">
        Welcome to GigSafe!
      </Typography>
      <Typography css={tw`text-center`} variant="body2" color={colors.SHADES_GREY_400}>
        Begin your onboarding as a Master Contractor to access the #1 workforce management platform
        for delivery operations.
      </Typography>
      <Typography css={tw`mt-8 mb-4 text-center`} variant="body2" color={colors.SHADES_GREY_400}>
        Streamline compliance, manage crews, and cut costs — all in one place.
      </Typography>
      <Button
        className={tw`w-full`}
        variant="contained"
        color="light"
        size="small"
        onClick={onNext}
        endIcon={<CircleRightMajor width={20} fill={colors.PRIMARY_PURPLE_500} />}
      >
        Start onboarding
      </Button>
    </div>
  )
}
